// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__vdse8","label":"LabeledBox_label__1RYu8"};